export const allowedProviders = [
  'sberbank',
  'vkontakte',
  'livejournal',
  'odnoklassniki',
  'mailru',
  'pgumosru',
  'championat'
]
